import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, $) {
  drupalComponent('nechSocialNetworksIcon', {
    selector: '.social-icon',

    shared: {
        shareLinkGenerator: function ($el: JQuery<HTMLElement>) {
          const currentUrl = window.location.href;
          let shareLink = '';

          if ($el.hasClass('facebook')) {
            shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
          }
          else if ($el.hasClass('instagram')) {
            shareLink = `https://www.instagram.com/$${encodeURIComponent(currentUrl)}`;
          }
          else if ($el.hasClass('linkedin')) {
            shareLink = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}`;
          }
          else if ($el.hasClass('twitter')) {
            shareLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(currentUrl)}`;
          }
               
          if (shareLink !== '') {
            window.open(shareLink, '_blank');
          }
        },
      },
      


    attach(context, options) {
      const self = this;

      const $elements = $(this.selector, context);

      $elements.each(function () {
        const $el = $(this);

        $el.on('click', function () {
          self.shared.shareLinkGenerator($el);
        });
      });
    },
  });
})(Drupal, jQuery);
